import 'css-chunksrc/client/scenes/planzoneResourceToProject/resourceToProjectForm/resourceSelection/selectedResourcesList/selectedResource/styles.scss';export default {
  "selectedResource": "_selectedResource_6qz8x_1",
  "removeIcon": "_removeIcon_6qz8x_23",
  "icon": "_icon_6qz8x_27",
  "resource": "_resource_6qz8x_45",
  "removeButton": "_removeButton_6qz8x_52"
};